/* eslint-disable camelcase */
import {
 all, call, put, select,
} from 'redux-saga/effects';
import queryString from 'query-string';
import { API } from '../../api';

const getServerConfig = ({ serverConfig }) => serverConfig;

const makeResult = (column, source, result) => {
  if (source) {
    return {
      [`${source}:${column}`]: result.result,
    };
  }
  return {
    [`${column}`]: result.result,
  };
};

function* fetchAggregate({
  serverConfig,
  filterString,
  property,
  input,
  prop,
}) {
  const {
    method,
    source,
    column,
    filterString: propertyFilterString,
    label,
  } = property;
  const { min } = prop;

  if (!input) {
    return makeResult(column, source, '');
  }
  if (input < min) {
    yield put({
      type: 'OPEN_SNACKBAR',
      payload: {
        message: `${label} requires a value over ${min}.`,
      },
    });
    return makeResult(column, source, '');
  }

  const [cleanedColumn] = column.split('+');
  try {
    const path = `/math/${
      serverConfig.namespace
    }/${method}?${queryString.stringify({
      input,
      key: source ? `${source}:${cleanedColumn}` : cleanedColumn,
    })
    }${
      filterString ? `&${filterString}` : ''
    }${
      propertyFilterString ? `&${propertyFilterString}` : ''
    }`;

    const result = yield call(API, 'get', 'api', path);

    return makeResult(column, source, result);
  } catch (e) {
    console.error('Error fetching bbox for multiparcel report', e);
    return null;
  }
}

export function* fetchComputed(action) {
  const { value, prop, reportContents } = action.payload;

  const { key } = reportContents;
  const { identifier } = reportContents.report;
  const { properties } = reportContents.report.sections[0];
  const dependentProperties = properties.filter(
    ({ input }) => input === prop.id,
  );

  const filterString = queryString.stringify({
    [identifier || 'parcel_id']: key,
  });

  const serverConfig = yield select(getServerConfig);
  const calls = dependentProperties.reduce((acc, property) => {
    acc.push(
      call(fetchAggregate, {
        serverConfig,
        filterString,
        property,
        input: value || 0,
        prop,
      }),
    );
    return acc;
  }, []);

  const results = yield all(calls);
  const columns = results.reduce((acc, result) => Object.assign(acc, result));

  yield put({
    type: 'UPDATE_REPORT_COMPUTED',
    payload: {
      key,
      columns,
    },
  });
  yield put({
    type: 'UPDATE_SIDE_PANEL_REPORT_COMPUTED',
    payload: {
      key,
      columns,
    },
  });
}
